import React from 'react';

import {
    Heading,
    Container,
    Row,
    Col,
    Text,
    className,
    ImageComponent,
} from 'aplazame-design-system';
import { default as ButtonComponent } from 'aplazame-design-system/src/components/GatsbyTransitionButtonComponent';

import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import sectionStyle from 'aplazame-design-system/src/scss/section.module.scss';
import transitionStyle from 'aplazame-design-system/src/scss/transitions.module.scss';

export default function FavoriteProductsSection({
    title,
    titleTag,
    id,
    products,
    colorScheme,
    ...props
}) {
    const hasColorScheme = colorScheme !== 'none';
    if (hasColorScheme) {
        colorScheme = colorScheme?.toLowerCase();
    }

    return (
        <section
            className={`${sectionStyle['with-bg']} ${sectionStyle['with-bg--none']
                } ${colorStyle[`with-bg--${colorScheme}`]}`}
            aria-labelledby={id}
        >
            {hasColorScheme ? (
                <div
                    data-sal="fade"
                    data-sal-easing="ease-out-quart"
                    className={`${sectionStyle.bg} ${colorStyle.bg}`}
                />
            ) : null}
            <Container pt={{ xs: 6, lg: 10 }} pb={{ xs: 6, lg: 10 }}>
                <Row>
                    {title ? (
                        <Col>
                            <Heading
                                id={id}
                                className={`h3 font-weight-bold text-center ${style.heading}`}
                                tag={titleTag}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                            >
                                {title}
                            </Heading>
                        </Col>
                    ) : null}

                    {products.map((product, i) => (
                        <Col
                            key={i}
                            className={
                                props.columns === '3' ? style.col3 : style.col4
                            }
                            mb={{
                                xs: 5,
                            }}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                            data-sal-delay={`xs-none--lg-${(i % 4) * 100}`}
                        >
                            <a
                                tabIndex={-1}
                                href={product.ctaUrl}
                                target="_blank"
                                rel="noopener nofollow"
                                aria-label={product.linkTitle + ' (se abre en una nueva pestaña)'}
                                // title={product.linkTitle}
                                {...className(
                                    `d-block mb-1 ${style['image-wrapper']}`
                                )}
                            >
                                <ImageComponent
                                    image={product.defaultImage}
                                    className={`d-none d-lg-block ${style.image}`}
                                    aspectRatio={1.2}
                                />
                                <ImageComponent
                                    image={product.defaultImage}
                                    aspectRatio={0.76}
                                    className="d-lg-none"
                                />
                            </a>
                            <Text tag="p" className={`body ${style.store}`}>
                                {product.store ? product.store.title : ' '}
                            </Text>
                            <a
                                href={product.ctaUrl}
                                target="_blank"
                                rel="noopener nofollow"
                                aria-label={product.linkTitle + ' - ' + product.subtitle + ` - Total ${product.priceTotal}` + ' (se abre en una nueva pestaña)'}
                                // title={product.linkTitle}
                                className={`${transitionStyle.link} ${style.productTitle}`}
                            >
                                <Heading
                                    tag="h2"
                                    className="h4 heading__collections"
                                    aria-hidden={true}
                                >
                                    {product.title}
                                </Heading>
                                <Heading
                                    tag="h3"
                                    className={`h4 heading__collections ${!product.priceTotal &&
                                        style.noPriceTotal
                                        }`}
                                    aria-hidden={true}
                                >
                                    {product.subtitle}
                                </Heading>
                                {product.priceTotal && (
                                    <div aria-hidden={true}>
                                        <Text
                                            tag="p"
                                            className={`body ${style.total}`}
                                            aria-hidden={true}
                                        >
                                            {`Total ${product.priceTotal}`}
                                        </Text>
                                    </div>
                                )}
                            </a>
                            <ButtonComponent
                                focusWhite={colorScheme == 'primary' ? true : false}
                                buttonClassName={style.btnBuy}
                                blockMobile={true}
                                dark={false}
                                hideArrow={true}
                                button={{
                                    label: `Comprar`,
                                    externalLink: product.ctaUrl,
                                    target: '_blank',
                                    detached: true,
                                    extraAttributes: {
                                        title: `${product.title}`,
                                        rel: 'noopener nofollow',
                                    },
                                }}
                            />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}
